export default __webpack_public_path__ + "static/about-shape-f77b10fb176d055fe0b6d7cd6af7081f.png";